import React from 'react';
import { Hero } from '../components/Hero';
import { ValueBar } from '../components/ValueBar';
import { Banner } from '../components/Banner';
import { ProblemSection } from '../components/ProblemSection';
import { WhatIDo } from '../components/WhatIDo';
import { Differences } from '../components/Differences';
import { PackageSection } from '../components/PackageSection';
import { About } from '../components/About';
import { Resources } from '../components/Resources';
import { WhoItsFor } from '../components/WhoItsFor';
import { FinalCTA } from '../components/FinalCTA';
export function Home() {
  return <>
      <Hero data-id="element-249" />
      <ValueBar data-id="element-250" />
      <Banner data-id="element-251" />
      <ProblemSection data-id="element-252" />
      <WhatIDo data-id="element-253" />
      <Differences data-id="element-254" />
      <PackageSection data-id="element-255" />
      <About data-id="element-256" />
      <Resources data-id="element-257" />
      <WhoItsFor data-id="element-258" />
      <FinalCTA data-id="element-259" />
    </>;
}